import { render, staticRenderFns } from "./AuditCandidates.vue?vue&type=template&id=51a87490"
import script from "./AuditCandidates.vue?vue&type=script&lang=js"
export * from "./AuditCandidates.vue?vue&type=script&lang=js"
import style0 from "./AuditCandidates.vue?vue&type=style&index=0&id=51a87490&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports